var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8921 9.10187C21.2471 15.5674 19.62 22.0758 15.2097 23.7028C10.8423 25.2871 5.36157 21.3907 3.00657 14.9251C0.651573 8.50241 2.27866 1.99406 6.64611 0.366969C11.0564 -1.26012 16.5371 2.67915 18.8921 9.10187Z",
    fill: "url(#paint0_linear_1_296)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25141 15.5676C-1.10358 9.14489 0.523505 2.63653 4.93377 1.00944L6.64649 0.367172C2.27905 1.99426 0.651959 8.50261 3.00696 14.9253C5.36195 21.3909 10.8427 25.2873 15.2101 23.703L13.4546 24.3453C9.08713 25.9296 3.60641 22.0331 1.25141 15.5676Z",
    fill: "url(#paint1_linear_1_296)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.379 9.3164C20.5199 15.0968 19.0213 20.9629 15.082 22.4187C11.1427 23.8746 6.21867 20.3635 4.07776 14.5402C1.93685 8.75976 3.43549 2.89368 7.37476 1.43787C11.314 -0.0179507 16.2381 3.49314 18.379 9.3164Z",
    fill: "url(#paint2_linear_1_296)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24442 1.48068C7.30151 1.45214 7.34432 1.43787 7.37287 1.43787C11.3121 -0.0179507 16.2362 3.49314 18.3771 9.3164C20.518 15.0968 19.0194 20.9629 15.0801 22.4187C15.023 22.4473 14.9802 22.4616 14.9517 22.4616C18.7625 20.9201 20.1755 15.1397 18.0774 9.40203C15.9793 3.66441 11.1409 0.196139 7.24442 1.48068Z",
    fill: "#A86314"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_296",
    x1: -0.461698,
    y1: 2.63633,
    x2: 14.7816,
    y2: -2.97285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_296",
    x1: 5.31913,
    y1: 27.5995,
    x2: -2.17404,
    y2: 7.26089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_296",
    x1: -18.1448,
    y1: 10.2584,
    x2: 18.7644,
    y2: -3.10085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin8);
export default __webpack_public_path__ + "static/media/coin8.02efebaf645ed6a49dbde096b98857ad.svg";
export { ForwardRef as ReactComponent };